// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1167":"d8bc7bf8bb5fcfb9","3491":"9a4ece201f685d3f","5956":"e2b4dc6f7f4dbfee"}[chunkId] + ".css";
};